<template>
<div class="mIndexList">
    <div class="sortList" v-for="(obj,index) in sortList" :key="obj.id">
        <div class="title">{{obj.name}}</div>
        <div class="courseList">
            <div class="course" :class="[(index==2&&index2==0) || (index==1&&index2==0)?'special':'']" v-for="(obj2, index2) in obj.contentcourse" :key="obj2.innerid" @click="gotoCourse(obj2)">
                <img class="coverurl" :src="obj2.coverurl" alt="">
                <div class="subject">{{obj2.subject}}</div>
                <div class="price" v-if="obj.id!='A03'">
                    <span class="tc-blue" v-if="obj2.feetype == 1">免费</span>
                    <div v-else class="price-box">
                        <span class="saleprice tc-red">￥{{obj2.saleprice}}</span>
                        <!--<span class="uprice tc-grey" v-if="obj2.uprice">￥{{obj2.uprice}}</span>-->
                        <span class="limit-label" v-if="obj2.islimitcount">限时折扣</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getMIndexCourse} from 'api/indexApi'
export default {
    name: 'mIndexList',
    data() {
        return {
            sortList: []
        }
    },
    mounted() {
        this.getIndex()
    },
    methods: {
        gotoCourse(obj) {
            this.$router.push({name: 'MCourseView', query: {cid: obj.innerid}})
            this.setRefresh(true)
        },
        getIndex() {
            this.setLoading(true)
            getMIndexCourse({
                data: {},
                success: data => {
                    this.setLoading(false)
                    this.sortList = data.data
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions(['setLoading', 'setRefresh'])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
.mIndexList {
    .sortList{
        margin-top: 0.2rem;
        background: $c-white;
        padding: 0.2rem 0.32rem;
        color: $c-black;
        .title{
            font-weight: 600;
            font-size: 0.32rem;
        }
        .courseList{
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            .course{
                width: calc(50% - 0.1rem);
                .coverurl{
                    margin-top: 0.2rem;
                    width: 100%;
                    height: 1.86rem;
                }
                .subject{
                    overflow: hidden;
                    width: 100%;
                    line-height: 0.4rem;
                    height: 0.8rem;
                    font-size: 0.28rem;
                    margin-top: 0.2rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
                .price{
                    margin-top: 0.2rem;
                    font-size: 0.28rem;
                    .price-box{
                        display: flex;
                        align-items: center;
                    }
                    .uprice{
                        margin-left: 0.2rem;
                        font-size: 0.24rem;
                        text-decoration:line-through
                    }
                    .limit-label{
                        margin-left: 0.2rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 1.04rem;
                        height: 0.32rem;
                        border-radius: 0.04rem;
                        border: 0.01rem solid #FF4747;
                        font-size: 0.2rem;
                        color: #FF4747;
                    }
                }
            }
            .special{
                width: 100%;
                .coverurl{
                    height: 3.86rem;
                }
                .subject{
                    font-size: 0.32rem;
                    line-height: 0.46rem;
                    height: auto;
                }
                .price{
                    font-size: 0.28rem;
                    .uprice{
                        font-size: 0.28rem;
                    }
                }
            }
        }
    }
}
</style>